class PerformanceRating extends HTMLElement {
  constructor() {
    super();
    this.rating = 0;
    this.maxRating = 10;
    this.animateOnScroll = true;
    this.animationDuration = 800;
    this.animationDelay = 100;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Get rating from data attribute
    const ratingData = this.getAttribute('data-rating');
    if (ratingData) {
      this.parseRating(ratingData);
    }

    // Set up intersection observer for scroll animation
    if (this.animateOnScroll) {
      this.setupIntersectionObserver();
    } else {
      // Animate immediately if no scroll animation
      this.animateBar();
    }
  }

  /**
   * Parse rating string into numeric values
   * @param {string} ratingString - Rating string (e.g., "9.2/10", "9.2", "92%")
   */
  parseRating(ratingString) {
    // Handle different rating formats: "9.2/10", "9.2", "92%", etc.
    if (ratingString && ratingString.includes('/')) {
      const [rating, max] = ratingString.split('/');
      this.rating = parseFloat(rating) || 0;
      this.maxRating = parseFloat(max) || 10;
    } else if (ratingString && ratingString.includes('%')) {
      this.rating = parseFloat(ratingString.replace('%', '')) || 0;
      this.maxRating = 100;
    } else if (ratingString) {
      this.rating = parseFloat(ratingString) || 0;
      this.maxRating = 10;
    } else {
      this.rating = 0;
      this.maxRating = 10;
    }

    // Ensure rating is within bounds
    this.rating = Math.max(0, Math.min(this.rating, this.maxRating));
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Start animation when element comes into view
          setTimeout(() => {
            this.animateBar();
          }, this.animationDelay);
          
          // Stop observing after animation starts
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(this);
  }

  animateBar() {
    console.log('animateBar');
    // Calculate percentage for the bar width
    const percentage = (this.rating / this.maxRating) * 100;
    
    // Animate the width from 0 to the calculated percentage
    this.style.width = '0%';
    
    // Force reflow
    this.offsetHeight;
    
    // Animate to final width
    this.style.width = `${percentage}%`;
    
    // Add animation class for additional effects
    this.classList.add('animating');
    
    // Remove animation class after animation completes
    setTimeout(() => {
      this.classList.remove('animating');
    }, this.animationDuration);
  }

  /**
   * Method to update rating dynamically
   * @param {number} newRating - New rating value
   */
  updateRating(newRating) {
    this.rating = newRating;
    this.animateBar();
  }

  // Method to reset animation
  reset() {
    this.style.width = '0%';
    this.classList.remove('animating');
  }
}

// Register the custom element
customElements.define('performance-rating', PerformanceRating);

// Export for potential module usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = PerformanceRating;
}
